import { useTranslate } from '@refinedev/core';
import { Tabs, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * E57 · Caseload — the three tabs a therapist opens (Q-pia-4 A: tables, never a badge, alert or notification): Overview
 * (/caseload), Homework (the E34 board, unchanged at /homework) and All records (/caseload/records).
 *
 * Behavior lines implemented here:
 *   · nav: the Homework tab opens the Homework board at /homework (caseload.tab.homework);
 *   · nav: the All records tab (caseload.tab.allRecords).
 */
export type CaseloadTab = 'overview' | 'homework' | 'records';

const PATHS: Record<CaseloadTab, string> = {
  overview: '/caseload',
  homework: '/homework',
  records: '/caseload/records',
};

export const CaseloadTabs: React.FC<{ active: CaseloadTab }> = ({ active }) => {
  const t = useTranslate();
  const navigate = useNavigate();
  return (
    <div data-testid="cc-caseload-tabs" style={{ padding: '0 0 0 0' }}>
      <Typography.Title level={3} style={{ marginBottom: 4 }} data-testid="cc-caseload-title">
        {t('caseload.title')}
      </Typography.Title>
      <Tabs
        activeKey={active}
        onChange={(key) => navigate(PATHS[key as CaseloadTab])}
        items={[
          { key: 'overview', label: <span data-testid="cc-caseload-tab-overview">{t('caseload.tab.overview')}</span> },
          { key: 'homework', label: <span data-testid="cc-caseload-tab-homework">{t('caseload.tab.homework')}</span> },
          { key: 'records', label: <span data-testid="cc-caseload-tab-records">{t('caseload.tab.allRecords')}</span> },
        ]}
      />
    </div>
  );
};
